// extracted by mini-css-extract-plugin
module.exports = {"root":"DialogToolboxCreate_root__3h-gd","errorMessage":"DialogToolboxCreate_errorMessage__1VcvM","sectorInput":"DialogToolboxCreate_sectorInput__3Ml0e"};